import { useI18n } from "../i18n";
import { requiredBy, toggle } from "../modules";
import type { Module } from "../types";

interface Props {
  catalog: Module[];
  enabled: Set<string>;
  onChange: (next: Set<string>) => void;
  disabled?: boolean;
  /** Show "Arrives in M3" for modules not built yet. */
  showMilestone?: boolean;
}

export function ModuleGrid({ catalog, enabled, onChange, disabled, showMilestone = true }: Props) {
  const { t, pick } = useI18n();
  return (
    <div className="module-grid">
      {catalog.map((m) => {
        const on = enabled.has(m.key);
        const needers = on ? requiredBy(m.key, enabled, catalog) : [];
        const locked = m.always_on || needers.length > 0;
        return (
          <label key={m.key} className={`module-tile${on ? " on" : ""}${locked ? " locked" : ""}`}>
            <input
              type="checkbox"
              id={`module-${m.key}`}
              checked={on}
              disabled={disabled || locked}
              onChange={() => onChange(toggle(m.key, enabled, catalog))}
            />
            <span className="box" aria-hidden="true">
              <svg width="12" height="12" viewBox="0 0 12 12">
                <polyline points="2,6.5 5,9.2 10,3" />
              </svg>
            </span>
            <span className="module-text">
              <span className="module-name">{pick(m.name_en, m.name_ar)}</span>
              <span className="module-desc">{m.description}</span>
              {m.always_on && <span className="module-note">{t("alwaysOn")}</span>}
              {!m.always_on && needers.length > 0 && (
                <span className="module-note">
                  {t("requiredBy")} {needers.map((n) => pick(n.name_en, n.name_ar)).join(", ")}
                </span>
              )}
              {showMilestone && m.milestone !== "M1" && (
                <span className="module-milestone">
                  {t("arrives")} {m.milestone}
                </span>
              )}
            </span>
          </label>
        );
      })}
    </div>
  );
}
